// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BookingAlerts_wrapper__v9EfN","item":"BookingAlerts_item__IBF0s","side":"BookingAlerts_side__sbzXU","main":"BookingAlerts_main__X1qWy"};